/*
 *
 * RefoundBackbookISP
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 11-Mar-2025
*/

import RefoundBackbookISP from './RefoundBackbookISPContainer'

export default RefoundBackbookISP
